module.exports = __webpack_public_path__ + "resources/img/logo_toast.36eded35cbeb8eaae57cdf7a059e145e.svg";